import { Link } from "react-router-dom";
import { peekListReturn } from "./list-return-state";

/** Detail → filtered list (or module list) — plan/35 Wave F. */
export function DeskDocBackLink(props: {
  /** Path without query, e.g. `/c/acme/sales/orders` */
  listBasePath: string;
  /** Fallback label when no stash, e.g. "Sales orders" */
  listLabel: string;
  className?: string;
}) {
  const stash = peekListReturn(props.listBasePath);
  const to = stash?.listPath ?? props.listBasePath;
  const label = stash
    ? "Back to filtered list"
    : `Back to ${props.listLabel}`;

  return (
    <Link
      to={to}
      className={
        props.className ??
        "text-sm text-[var(--color-muted)] no-underline hover:text-[var(--color-foreground)] hover:underline"
      }
    >
      ← {label}
    </Link>
  );
}
